export default () => `<?xml version="1.0" encoding="utf-8"?>
<com.google.android.material.button.MaterialButton
    xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    android:id="@+id/reader_name"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:text="Example Serial Number"
    app:cornerRadius="0dp"
    android:textAlignment="textStart" />
`;
